import React from 'react';
import { LocaleUtils } from 'react-day-picker';
import styles from './DatePickerCaption.module.scss';

interface Props {
  date: Date;
}

const DayPickerCaption = (props: Props) => {
  const { date } = props;
  const months = LocaleUtils.getMonths();

  return (
    <div className={styles.container} role="heading" aria-level={5} aria-live="polite">
      <h5>{months[date.getMonth()]}</h5>
    </div>
  );
};

export default DayPickerCaption;
